import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageStateByPath } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { shallowEqual, useSelector } from "react-redux";

const categoryPageTypes = new Set(["CategoryDetailsPage", "ProductListPage", "ProductDetailsPage"]);

const useItemCategoryData = (options?: Toolkit.GoogleAnalytics.Options): Partial<Toolkit.GoogleAnalytics.Item> => {
    const itemCategoryData = useSelector((state: ApplicationState) => {
        const pageType = getPageStateByPath(state, state.data.pages.location.pathname).value?.type;

        if (!pageType || !categoryPageTypes.has(pageType)) {
            return {};
        }

        const breadcrumbLinks = state.components.breadcrumbs.links;

        if (!breadcrumbLinks?.length) {
            return {};
        }

        const categories = breadcrumbLinks
            .slice(2)
            .map(link => link.children?.toString().trim())
            .filter((value): value is string => Boolean(value));

        const categoryLevels = pageType === "ProductDetailsPage" ? categories.slice(0, -1) : categories;

        if (!categoryLevels.length) {
            return {};
        }

        const [item_category, item_category2, item_category3] = categoryLevels;

        return {
            item_category,
            item_category2,
            item_category3,
        };
    }, shallowEqual);

    return itemCategoryData;
};

export default useItemCategoryData;